import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ConsultingHome from "./pages/ConsultingHome";
import Absicherungscheck from "./pages/Absicherungscheck";
import FinancialApp from "./pages/FinancialApp";
import StrategySession from "./pages/StrategySession";
import ZinsenBerechnen from "./pages/ZinsenBerechnen";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import UeberMich from "./pages/UeberMich";
import Philosophie from "./pages/Philosophie";
import Zusammenarbeit from "./pages/Zusammenarbeit";
import Strategiefelder from "./pages/Strategiefelder";
import PrintAnalysis from "./pages/PrintAnalysis";
import Rechner from "./pages/Rechner";
import RentenCheckPage from "./pages/RentenCheckPage";
import Kontakt from "./pages/Kontakt";
import { Toaster } from "./components/ui/sonner";
import { CookieConsentProvider } from "./context/CookieConsentContext";
import { CookieBanner, CookieModal } from "./components/legal";
import { ScrollToTop } from "./components/ScrollToTop";

function App() {
  return (
    <CookieConsentProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<ConsultingHome />} />
            <Route path="/absicherungscheck" element={<Absicherungscheck />} />
            <Route path="/app" element={<FinancialApp />} />
            <Route path="/zinsen" element={<ZinsenBerechnen />} />
            <Route path="/strategiegespraech" element={<StrategySession />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/ueber-mich" element={<UeberMich />} />
            <Route path="/philosophie" element={<Philosophie />} />
            <Route path="/zusammenarbeit" element={<Zusammenarbeit />} />
            <Route path="/strategiefelder" element={<Strategiefelder />} />
            <Route path="/rechner" element={<Rechner />} />
            <Route path="/rentencheck" element={<RentenCheckPage />} />
            <Route path="/kontakt" element={<Kontakt />} />
            {/* Redirect from old URL to new URL */}
            <Route path="/finanzfahrplan" element={<Navigate to="/rentencheck" replace />} />
            <Route path="/print" element={<PrintAnalysis />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
        {/* GDPR Cookie Consent Components */}
        <CookieBanner />
        <CookieModal />
      </div>
    </CookieConsentProvider>
  );
}

export default App;
